import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'radius-bottom-right',
  'IconRadiusBottomRight',
  [['path', { d: 'M19 5v6a8 8 0 0 1 -8 8h-6', key: 'svg-0' }]],
);
